// import { doc, getDoc } from "firebase/firestore";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { auth, db } from "../../firebase.config";
// // import { sendEmailVerification } from "firebase/auth";
// import authService from "../../services/auth.service";

// export default function PaymentSuccess() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [userData, setUserData] = useState(null);
//   const [emailVerified, setEmailVerified] = useState(false);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [guestPayment, setGuestPayment] = useState(false);

//   useEffect(() => {
//     if (location.state?.paymentSuccess) {
//       setGuestPayment(true);
//       return;
//     }

//     const fetchUserData = async () => {
//       try {
//         const user = auth.currentUser;
//         if (!user) return;

//         setEmailVerified(user.emailVerified);
//         setCurrentUser(user);

//         const userDocRef = doc(db, "users", user.uid);
//         const userDocSnapshot = await getDoc(userDocRef);

//         if (userDocSnapshot.exists()) {
//           setUserData(userDocSnapshot.data());
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       }
//     };

//     fetchUserData();
//   }, [location.state]);

//   const handleContinue = async () => {
//     if (guestPayment) {
//       const user = auth.currentUser;
//       if (user?.email) {
//         await authService.sendVerificationEmail(user?.email);
//       }
//       navigate("/verify-email");
//     } else if (!emailVerified) {
//       await authService.sendVerificationEmail(currentUser.email);
//       navigate("/verify-email");
//     } else if (!userData?.accept_terms) {
//       navigate("/disclaimer");
//     } else if (!userData?.profileImage) {
//       navigate("/profile");
//     } else {
//       navigate("/dashboard");
//     }
//   };
//   return (
//     <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
//       {/* Checkmark */}
//       <div className="bg-[#EBF3EA] p-14 w-fit rounded-full mb-6">
//         <div className="bg-[#CBEEC9] p-6 w-fit rounded-full">
//           <div className="bg-green-600 p-4 w-fit rounded-full">
//             <svg
//               className="size-8 text-white"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2}
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M5 13l4 4L19 7"
//               />
//             </svg>
//           </div>
//         </div>
//       </div>

//       {/* Message */}
//       <h1 className="text-3xl font-bold text-[#281D1BB2] mb-8">
//         Payment Successful!
//       </h1>

//       {guestPayment && (
//         <p className="text-[#281D1BB2] mb-6 max-w-md">
//           "Your account has been successfully created!

//           We have sent an email to your inbox. Please click the link inside to set your password and log in."
//         </p>
//       )}

//       {/* <button
//         onClick={handleContinue}
//         className="bg-[image:--gradient] font-semibold text-white px-8 py-3 rounded-lg hover:opacity-70"
//         style={{
//           "--gradient":
//             "linear-gradient(90deg,rgb(5, 5, 5) 0%,rgb(10, 10, 10) 100%)",
//           boxShadow: "0px 4px 29.2px 7px #00000040",
//         }}
//       >
//         Continue
//       </button> */}
//     </div>
//   );
// }
import { doc, getDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase.config";
import authService from "../../services/auth.service";
import useAuth from "../../hooks/useAuth";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (!user) return;

        const userDocRef = doc(db, "users", user.uid);
        const userDocSnapshot = await getDoc(userDocRef);

        if (userDocSnapshot.exists()) {
          setUserData(userDocSnapshot.data());
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [user]);

  const handleContinue = async () => {
    if (!user) {
      navigate("/login");
      return;
    }

    if (!user.emailVerified) {
      await authService.sendVerificationEmail(user.email);
      navigate("/verify-email");
    } else if (!userData?.accept_terms) {
      navigate("/disclaimer");
    } else if (!userData?.profileImage) {
      navigate("/profile");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
      {/* Checkmark */}
      <div className="bg-[#EBF3EA] p-14 w-fit rounded-full mb-6">
        <div className="bg-[#CBEEC9] p-6 w-fit rounded-full">
          <div className="bg-green-600 p-4 w-fit rounded-full">
            <svg
              className="size-8 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Message */}
      <h1 className="text-3xl font-bold text-[#281D1BB2] mb-8">
        Payment Successful!
      </h1>

      {/* Show message if user is NOT logged in (Guest/New User from Kajabi) */}
      {!user && (
        <p className="text-[#281D1BB2] mb-6 max-w-md">
          Your account has been successfully created! We have sent an email to
          your inbox. Please click the link inside to set your password and log
          in.
        </p>
      )}

      {/* <button
        onClick={handleContinue}
        className="bg-[image:--gradient] font-semibold text-white px-8 py-3 rounded-lg hover:opacity-70"
        style={{
          "--gradient":
            "linear-gradient(90deg,rgb(5, 5, 5) 0%,rgb(10, 10, 10) 100%)",
          boxShadow: "0px 4px 29.2px 7px #00000040",
        }}
      >
        Continue
      </button> */}
    </div>
  );
}
